import {get} from 'lodash';

export default (data) => {

  const items = data && data.map(item => {
    const title = get(item, 'faqTabTitle', null);
    const accordionItemsArr = item.faqTabAccordionItemsRep ? get(item, 'faqTabAccordionItemsRep', []) : []
    const accordionItems = accordionItemsArr.map(accordionItem => {
      return {
        title: accordionItem.faqAccordionHeading,
        caption: accordionItem.faqAccordionText
      }
    })
    return title ? {
      title,
      data: accordionItems
    } : {}
  })

  return items

  // Goal
  // [{
  //   "title": 'Cat 1',
  //   "data": [
  //     {
  //       "title": "culpa Duis in dolor",
  //       "caption": "ut dolore minim ad"
  //     },
  //     {
  //       "title": "reprehenderit",
  //       "caption": "mollit do reprehenderit"
  //     },
  //     {
  //       "title": "pariatur aliquip",
  //       "caption": "cillum laborum"
  //     }
  //   ]
  // }]
}